import PropTypes from 'prop-types';
import React from 'react';
import commonsApi from './../../api/Common.api'
import { FormattedMessage } from 'react-intl';
import LightSpinnerWrapper from './../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper.jsx';
import IndexTermHelpRows from './IndexTermHelp.Rows';

class IndexTermHelp extends React.Component {

    static propTypes = {
        position:          PropTypes.string,
        pguids:            PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.state = {
            isIndexTermHelpVisible: false,
            isLoading:              false
        };
        this.toggleIndexTermHelpVisibility = this.toggleIndexTermHelpVisibility.bind(this);
        this.keyPress = this.keyPress.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.keyPress);
        this.setState({isLoading: true});

        let pguids = [];
        for (let i = 0; i < this.props.pguids.length; i++) {
            pguids.push(this.props.pguids[i].pguid);
        }

        commonsApi.getPguidDescriptions(pguids)
            .then((response) => {
                this.setState({isLoading: false})
            });

    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keyPress);
    }

    toggleIndexTermHelpVisibility() {
        this.setState({isIndexTermHelpVisible: !this.state.isIndexTermHelpVisible});
    }

    keyPress(event) {
        if (this.state.isIndexTermHelpVisible && event.key == "Escape" || event.key == "Esc" || event.keyCode == 27) {
            this.setState({isIndexTermHelpVisible: false});
        }
    }

    render() {

        let position;
        this.props.position === 'left' || this.props.position === 'right' ?
            position = this.props.position
            :
            position = 'right';

        return (

            <span className={'index-term-help no-print ' + position}>

                <span className="la-Help" onClick={this.toggleIndexTermHelpVisibility}></span>

                {
                    this.state.isIndexTermHelpVisible &&

                        <div className="index-term-help__popup">

                            <div className="index-term-help__popup--overlay" onClick={this.toggleIndexTermHelpVisibility}></div>

                            <div className="index-term-help__popup--header">
                                <FormattedMessage id="General_CoreFunctionality_UIText_termDefinitions"/>
                                <span className="la-CloseRemove" onClick={this.toggleIndexTermHelpVisibility}></span>
                            </div>

                            <LightSpinnerWrapper isLoading={this.state.isLoading}>
                                <div className="index-term-help__popup--body">

                                    <div className="row risk-angle-description">
                                        <FormattedMessage id="General_CoreFunctionality_UIText_termDefinitions.description"/>
                                    </div>

                                    <IndexTermHelpRows pguids={this.props.pguids} />

                                </div>
                            </LightSpinnerWrapper>

                            <div className={"index-term-help__arrow " + position}></div>
                            <div className={"index-term-help__arrow-mask " + position}></div>

                        </div>
                }

            </span>
        )
    }

}

export default IndexTermHelp;


// WEBPACK FOOTER //
// ./src/scripts/reusable/IndexTermHelp/IndexTermHelp.jsx